var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreTeste(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_4802",
    "data-name": "Grupo 4802",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.455,
    height: 13.455,
    viewBox: "0 0 13.455 13.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3758",
    "data-name": "Caminho 3758",
    d: "M0,0H13.455V13.455H0Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3759",
    "data-name": "Caminho 3759",
    d: "M12.091,3H3.121A1.125,1.125,0,0,0,2,4.121V11.97a1.125,1.125,0,0,0,1.121,1.121h8.97a1.125,1.125,0,0,0,1.121-1.121V4.121A1.125,1.125,0,0,0,12.091,3ZM6.485,10.849h-2.8V9.727h2.8Zm0-2.242h-2.8V7.485h2.8Zm0-2.242h-2.8V5.242h2.8Zm2.7,3.364L7.606,8.135l.79-.79.79.8,1.777-1.777.8.8Z",
    transform: "translate(-0.879 -1.318)",
    fill: "#feac0e",
    stroke: "#000",
    strokeWidth: 0,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreTeste);
export default __webpack_public_path__ + "static/media/pre-teste.464b1a8f08f6d39a6174d33b83a10467.svg";
export { ForwardRef as ReactComponent };